import React from "react";
import RacingPromotionsApp from "./App";
import { Helmet } from "react-helmet";
import "./styles.css";

/**
 * Render react app with redux store
 */
interface IProps {
  selectedCountry: string;
  isDesktopResolution: boolean;
}

const RacingPromotions: React.FC<IProps> = ({
  selectedCountry,
  isDesktopResolution,
}) => {
  return (
    <React.Fragment>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Free Matched Betting Reload Offers & Resources</title>
      </Helmet>
      <RacingPromotionsApp
        selectedCountry={selectedCountry}
        isDesktopResolution={isDesktopResolution}
      />
    </React.Fragment>
  );
};

export default RacingPromotions;
